import React, { useState, useRef } from "react";
import {
  GoogleMap,
  useLoadScript,
  Marker,
  Autocomplete,
} from "@react-google-maps/api";
import { useTranslation } from 'next-i18next'
import {BootstrapDialog,Customebtn} from "../StyledComponent/HintDialog1.style"
// import { getCookieValue } from "../../helpers/helpers";
import LoadingJSON from "../Loaders/Loading";
const Map = ({callbackLocation,open,currentLocate},props) => {
//   const [selectedPlace, setSelectedPlace] = useState(null);
//   const [searchLngLat, setSearchLngLat] = useState(null);
// console.log("currentLocation",currentLocate)
  const [currentLocation, setCurrentLocation] = useState(currentLocate);
  const autocompleteRef = useRef(null);

  const { t } = useTranslation("common")
  // laod script for google map
  const { isLoaded,loadError } = useLoadScript({
    googleMapsApiKey:'AIzaSyAuWlArly2_UH_eteQV4RKoaL28STfbf2E',
    libraries: ["places"],
  });

  if (!isLoaded) 
  {
    if(loadError&&loadError.type!="error"){
      return   <div style={{ textAlign: "center" }}>
      <LoadingJSON />
    </div>;
    }  
    if(!currentLocation){
        return "غير قادر على تحديد موقعك"
    }
    else{
     return <div>{t("noInternetConnect")}</div>  
    }
  
}


  // handle place change on search
  const handlePlaceChanged = (e) => {
    // console.log("e=====>",e)
    if(e){
   
    setCurrentLocation({
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
    });
    // callbackLocation({
    //   lat: e.latLng.lat(),
    //   lng: e.latLng.lng(),
    // })

    }
    else{
    const place = autocompleteRef.current.getPlace();
 
  
    setCurrentLocation({

      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    });
    // callbackLocation({
    //   lat: place.geometry.location.lat(),
    //   lng: place.geometry.location.lng(),
    // })
    // setCurrentLocation(null);
  }
  };
  // get current location
  const handleGetLocationClick = () => {
    if (navigator.geolocation) {

      navigator.geolocation.getCurrentPosition(
        (position) => {
         
          const { latitude, longitude } = position.coords;
        //   setSelectedPlace(null);
        //   setSearchLngLat(null);
          setCurrentLocation({ lat: latitude, lng: longitude });
        },
        (error) => {
          console.log(error);
        }
      );
    } else {
      // console.log("Geolocation is not supported by this browser.");
    }
  };

  // on map load
  const onMapLoad = (map) => {

    const controlDiv = document.createElement("div");
    const controlUI = document.createElement("div");
    controlUI.innerHTML = t("yourLocation");
    controlUI.style.backgroundColor = "white";
    controlUI.style.color = "black";
    controlUI.style.border = "2px solid #ccc";
    controlUI.style.borderRadius = "3px";
    controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
    controlUI.style.cursor = "pointer";
    controlUI.style.marginBottom = "22px";
    controlUI.style.textAlign = "center";
    controlUI.style.width = "100%";
    controlUI.style.padding = "8px 0";
    controlUI.addEventListener("click", handleGetLocationClick);
    controlDiv.appendChild(controlUI);

    // const centerControl = new window.google.maps.ControlPosition(
    //   window.google.maps.ControlPosition.TOP_CENTER,
    //   0,
    //   10
    // );

    map.controls[window.google.maps.ControlPosition.TOP_CENTER].push(
      controlDiv
    );
  };

  return (
    <BootstrapDialog open={open} 
    // anchorEl={anchorRef.current}
    maxWidth={"sm"}
    PaperProps={{
    sx: { overflow: "visible", position: "relative",direction:"rtl",width:"100%" },

    }}
    >
    {currentLocation?<div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "20px",
      }}
    >
      {/* search component  */}
      <Autocomplete
        onLoad={(autocomplete) => {
     
          autocompleteRef.current = autocomplete;
        }}
        onPlaceChanged={handlePlaceChanged}
        options={{ fields: ["address_components", "geometry", "name"] }}
      >
        <input type="text" placeholder={t("Searchlocation")} />
      </Autocomplete>

      {/* map component  */}
      <GoogleMap
        zoom={currentLocation ? 18 : 12}
        center={currentLocation}
        defaultCenter={currentLocation}
        mapContainerClassName="map"
        mapContainerStyle={{ width: "80%", height: "400px", margin: "auto" , zIndex:9999}}
        onLoad={onMapLoad}
        onClick={ (e)=>handlePlaceChanged(e)}
        // options={{streetViewControl:false,mapTypeControl:false}}
      >
     
        {currentLocation && <Marker position={currentLocation} />}
  
      </GoogleMap>
      <Customebtn
            variant={"contained"}
                color="secondary"
            onClick={()=>    {       
                callbackLocation(currentLocation)
            }}
          >
          {t("lblSpecification")}
    
          </Customebtn>
    </div>:""}
    </BootstrapDialog>
  );
};

export default Map;